// extracted by mini-css-extract-plugin
module.exports = {"statsBar":"home_statsBar__2rIGL","stat":"home_stat__1w3RY","number":"home_number__24C8F","tablet":"home_tablet__2tWtP","mobile":"home_mobile__3cVjW"};